import React from 'react';

/** UseCases.jsx — beige-theme redesign. Drop-in replacement. Self-contained. */
const USE_CASES = [
  { icon: '🔨', tint: '#F6E7E1', title: 'Construction & Trades', body: 'Automate job scheduling, subcontractor coordination, quote follow-up, and site documentation.' },
  { icon: '⚕️', tint: '#EAEDE2', title: 'Clinics & Healthcare', body: 'Automate patient scheduling, intake processing, communications, and after-hours triage.' },
  { icon: '🏦', tint: '#F0EEE7', title: 'Finance & Accounts', body: 'Automate invoice processing, reconciliation, client reporting, and compliance documentation.' },
  { icon: '📦', tint: '#EFEDE6', title: 'Warehousing & Logistics', body: 'Automate order processing, dispatch coordination, inventory reporting, and supplier communication.' },
  { icon: '⚙️', tint: '#F6E7E1', title: 'Manufacturing & Industrial', body: 'Automate production scheduling, maintenance workflows, compliance reporting, and supplier management.' },
  { icon: '📈', tint: '#EAEDE2', title: 'SMEs & Enterprise', body: 'Configurable automation stack for single-site SMEs and multi-site enterprise operations.' },
];

const UseCases = () => (
  <section id="use-cases" className="cai-uc">
    <div className="cai-uc-inner">
      <div className="cai-uc-head">
        <h2 className="cai-uc-h2">Sector-specific automation across your business operations</h2>
        <p className="cai-uc-sub">Configured for your workflows, integrated with the systems you already use, and deployed by our team.</p>
      </div>
      <div className="cai-uc-grid">
        {USE_CASES.map((u) => (
          <div key={u.title} className="cai-uc-card">
            <div className="cai-uc-icon" style={{ background: u.tint }}>{u.icon}</div>
            <h3 className="cai-uc-card-title">{u.title}</h3>
            <p className="cai-uc-card-body">{u.body}</p>
          </div>
        ))}
      </div>
    </div>
    <style>{`
      .cai-uc { background: #ECEAE3; padding: 96px 40px 0; }
      .cai-uc-inner { max-width: 1200px; margin: 0 auto; }
      .cai-uc-head { text-align: center; max-width: 760px; margin: 0 auto 48px; }
      .cai-uc-h2 { font-size: 42px; font-weight: 800; letter-spacing: -0.025em; margin: 0; line-height: 1.1; color: #1A1A18; }
      .cai-uc-sub { font-size: 18px; line-height: 1.55; color: #5A564D; margin: 18px 0 0; }
      .cai-uc-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
      .cai-uc-card { background: #fff; border-radius: 20px; padding: 30px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); transition: transform .2s; }
      .cai-uc-card:hover { transform: translateY(-4px); }
      .cai-uc-icon { width: 54px; height: 54px; border-radius: 15px; display: flex; align-items: center; justify-content: center; font-size: 26px; margin-bottom: 18px; }
      .cai-uc-card-title { margin: 0 0 10px; font-size: 20px; font-weight: 700; letter-spacing: -0.01em; color: #1A1A18; }
      .cai-uc-card-body { margin: 0; font-size: 15px; line-height: 1.55; color: #5A564D; }
      @media (max-width: 900px) { .cai-uc-grid { grid-template-columns: 1fr; } .cai-uc { padding: 64px 22px 0; } .cai-uc-h2 { font-size: 32px; } }
    `}</style>
  </section>
);

export default UseCases;
